import { render, staticRenderFns } from "./SidebarPayments.vue?vue&type=template&id=b474a72a&scoped=true"
import script from "./SidebarPayments.vue?vue&type=script&lang=js"
export * from "./SidebarPayments.vue?vue&type=script&lang=js"
import style0 from "./SidebarPayments.vue?vue&type=style&index=0&id=b474a72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b474a72a",
  null
  
)

export default component.exports